const hotels = {
  name: 'Hotel |||| Hoteles',
  fields: {
    name: 'Nombre',
    hotelChainName: 'Cadena',
    hotelCategoryName: 'Tipología',
    address: 'Dirección',
    city: 'Ciudad',
    region: 'Región / Provincia',
    country: 'País',
    latitude: 'Latitud',
    longitude: 'Longitud',
    pmsSystemName: 'PMS',
    lockSystemName: 'Cerradura',
    paymentProcessorName: 'Procesador de pago',
    leadCount: 'Nº leads',
    notes: 'Observaciones',
  },
  empty: 'No se encontraron hoteles',
  invite: 'Cree su primer hotel',
};

export default hotels;
